import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=0070956d&scoped=true"
import script from "./MyAccount.vue?vue&type=script&lang=ts"
export * from "./MyAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0070956d",
  null
  
)

export default component.exports